/**
 * The dashboard's route, owned by the feature. Same shape as audit's, kyc's and synthetic's.
 */
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const DashboardPage = lazy(() => import('./DashboardPage'));

export const dashboardRoutes: RouteObject[] = [{ path: 'dashboard', element: <DashboardPage /> }];
